<template>
    <div>

        <Head title="Edit Online Sales Order" />
        <h1 class="mb-8 text-3xl font-bold">
            <Link class="text-orange-600 hover:text-orange-500" href="/online-orders">Online Sales Orders</Link>
            &raquo;{{ order.order_no }}: {{
                order.customer }}
        </h1>
        <div class="max-w-6xl bg-white rounded-md shadow">
            <form @submit.prevent="store">
                <div v-if="stepOne">
                    <div class="grid grid-cols-1 gap-4 pr-8 pl-8 pt-5 pb-2">
                        <div class="flex flex-wrap">
                            <select-input v-model="formData.payment_detail" :error="$props.errors.payment_detail"
                                class="pr-6 w-1/2 lg:w-1/2" label="Payment Details">
                                <option :value="null">-Select-</option>
                                <option v-for="payment in payment_details" :key="payment">{{ payment }}</option>
                            </select-input>
                            <select-input v-model="formData.shipping_type" :error="$props.errors.shipping_type"
                                class="pr-6 w-1/2 lg:w-1/2" label="Shipping Type">
                                <option :value="null">-Select-</option>
                                <option v-for="shipping_type in shipping_types" :key="shipping_type">{{ shipping_type }}
                                </option>
                            </select-input>
                        </div>
                    </div>
                    <div v-if="formData.shipping_type === 'Pickup'" class="grid grid-cols-1 gap-4 pr-8 pl-8 pt-2 pb-2">
                        <div class="flex flex-wrap">
                            <select-input v-model="formData.pickup_location" :error="$props.errors.pickup_location"
                                class="pr-6 w-full lg:w-full" label="Pick Up Location">
                                <option :value="null">-Select-</option>
                                <option v-for="pickup_location in pickup_locations" :key="pickup_location">
                                {{ pickup_location }}
                                </option>
                            </select-input>
                        </div>
                    </div>
                    <div class="grid grid-cols-1 gap-4 pr-8 pl-8 pt-2 pb-2">
                        <div class="flex flex-wrap">
                            <select-input v-model="formData.point_of_sale" :error="$props.errors.point_of_sale"
                                class="pr-6 w-1/2 lg:w-1/2" label="Point Of Sale">
                                <option :value="null">-Select-</option>
                                <option v-for="point_of_sale in points_of_sale" :key="point_of_sale">{{ point_of_sale }}
                                </option>
                            </select-input>

                            <text-input v-model="formData.delivery_date" type="date"
                                :error="$props.errors.delivery_date" class="pr-6 w-1/2 lg:w-1/2"
                                label="Delivery Date" />
                        </div>
                    </div>
                    <div class="grid grid-cols-1 gap-4 pr-14 pl-8 pt-2 pb-2">
                        <div class="flex flex-wrap">
                            <label class="pb-2">Referral:</label>
                            <multiselect id="referral" v-model="formData.referral" placeholder="Search Referrals"
                                :options="referrals" :clear-on-select="false" :preserve-search="true" :searchable="true"
                                class="mt-1 w-full" :close-on-select="true" :create-option="true"
                                :error="$props.errors.referral"
                                :style="$props.errors.referral ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''"
                                @search-change="onSearchReferralChange" />
                            <p v-if="$props.errors" class="text-red-700 pt-2"><small>{{ $props.errors.referral
                                    }}</small></p>
                        </div>
                    </div>
                    <div class="grid grid-cols-1 gap-4 pr-8 pl-8 pt-2 pb-2">
                        <div class="flex flex-wrap">
                            <text-input v-model="formData.notes" :error="$props.errors.notes"
                                class="pr-6 w-full lg:w-full" label="Notes" />
                        </div>
                    </div>
                    <div class="grid grid-cols-1 gap-4 pr-14 pl-8 pt-2 pb-2">
                        <div class="flex flex-wrap">
                            <label class="pb-2">Responsible Agent:</label>
                            <multiselect id="responsible_agent" v-model="formData.responsible_agent"
                                placeholder="Search Agents" :options="agents" :clear-on-select="true" :searchable="true"
                                class="mt-1 w-1/2" :error="$props.errors.responsible_agent"
                                :style="$props.errors.responsible_agent ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''" />
                            <p v-if="$props.errors" class="text-red-700 pt-2"><small>{{ $props.errors.responsible_agent
                                    }}</small>
                            </p>
                        </div>
                    </div>
                    <div class="grid grid-cols-1 gap-4 pr-14 pl-8 pt-2 pb-2">
                        <div class="flex flex-wrap">
                        <label class="pb-2">Assisting Agent:</label>
                        <multiselect id="responsible_agent" v-model="formData.assisting_agent" placeholder="Search Assisting Agents"
                            :options="agents" :clear-on-select="true" :searchable="true" class="mt-1 w-1/2"
                            :error="$props.errors.assisting_agent"
                            :style="$props.errors.assisting_agent ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''" />
                        <p v-if="$props.errors" class="text-red-700 pt-2"><small>{{ $props.errors.assisting_agent }}</small>
                        </p>
                        </div>
                    </div>
                    <div v-if="formData.payment_detail === 'Prepaid'"
                        class="grid grid-cols-1 gap-4 pr-14 pl-8 pt-2 pb-2">
                        <div class="flex flex-wrap w-full">
                            <div class="bg-orange-50 rounded-md shadow overflow-x-auto mb-4 w-full">
                                <div class="grid grid-cols-1 gap-4 p-1">
                                    <div class="pt-2 p-2">
                                        <h1 style="font-size:20px; font-weight: bold;">
                                            Payment Details
                                        </h1>
                                    </div>
                                </div>
                            </div>
                            <div class="w-full mb-4">
                                <div class="w-full grid grid-cols-1 gap-4 p-3">
                                    <div v-for="(pitem, pindex) in formData.payments" :key="pindex"
                                        class="flex flex-wrap">
                                        <div class="w-1/4 pr-2">
                                            <label class="form-label">Select Mode of Payment:</label>
                                            <multiselect id="provider" :key="pindex" v-model="pitem.payment_provider"
                                                placeholder="Search Payment Mode" :options="providers"
                                                :clear-on-select="false" :preserve-search="true" :searchable="true"
                                                class="pr-1" :create-option="true"
                                                :error="showValidationErrors(`payments.${pindex}.payment_provider`)"
                                                :style="showValidationErrors(`payments.${pindex}.payment_provider`) ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''"
                                            />
                                            <div v-if="showValidationErrors(`payments.${pindex}.payment_provider`)"
                                                class="form-error">
                                                {{  showValidationErrors(`payments.${pindex}.payment_provider`) }}
                                            </div>
                                        </div>
                                        <div class="w-1/4 pr-2">
                                            <text-input :key="pindex" v-model="pitem.date" type="date"
                                                :error="showValidationErrors(`payments.${pindex}.date`)"
                                                class="pb-2 pr-1 w-full lg:w-full" label="Date" />
                                        </div>
                                        <div class="w-1/4 pr-2">
                                            <text-input :key="pindex" v-model="pitem.reference"
                                                :error="showValidationErrors(`payments.${pindex}.reference`)"
                                                class="pb-2 pr-1 w-full lg:w-full" label="Reference" />
                                        </div>
                                        <div class="w-1/4 pr-2 flex flex-wrap">
                                            <div class="w-1/2 pr-2">
                                                <text-input :key="pindex" v-model="pitem.amount" type="number"
                                                    :error="showValidationErrors(`payments.${pindex}.amount`)"
                                                    class="pb-2 pr-1 w-full lg:w-full" label="Amount" />
                                                <text-input :key="pindex" v-model="pitem.id" type="hidden"
                                                    :error="showValidationErrors(`payments.${pindex}.id`)" />
                                            </div>
                                            <div class="w-1/2 pr-2">
                                                <svg v-show="pindex === countOrderPayments"
                                                    xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                    stroke-width="1.5" stroke="currentColor"
                                                    class="w-6 h-6 mt-8 text-green-600"
                                                    style="display: inline !important; cursor: pointer;"
                                                    @click="addPaymentItem">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                </svg>
                                                <svg v-show="formData.payments.length > 0"
                                                    xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                    stroke-width="1.5" stroke="currentColor"
                                                    class="w-6 h-6 text-red-600 mt-8"
                                                    style="display: inline !important; cursor: pointer;"
                                                    @click="removePaymentItem(pindex, formData.payments)">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-show="formData.payments.length == 0" class="w-1/2 pr-2">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                            stroke-width="1.5" stroke="currentColor" class="w-6 h-6 mt-1 text-green-600"
                                            style="display: inline !important; cursor: pointer;"
                                            @click="addPaymentItem">
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="grid grid-cols-1 gap-4 pr-14 pl-8 pt-2 pb-2">
                        <div class="flex flex-wrap">
                        <label class="pb-2">Order Type:</label>
                        <label v-show="formData.order_type =='Freshworks'"  class="pb-2"> {{ formData.order_type }}</label>
                        <multiselect v-show="formData.order_type !='Freshworks'" id="order_type" v-model="formData.order_type" placeholder="Search Order Type" :options="orderTypes"
                            :clear-on-select="false" :preserve-search="true" :searchable="true" class="mt-1 w-full"
                            :close-on-select="true" :create-option="true" :error="$props.errors.order_type"
                            :style="$props.errors.order_type ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''"
                        />
                        <p v-if="$props.errors" class="text-red-700 pt-2"><small>{{ $props.errors.order_type }}</small></p>
                        </div>
                    </div>
                    <div class="grid grid-cols-1 gap-4 pr-14 pl-8 pt-2 pb-2">
                        <div class="flex flex-wrap">
                            <span class="flex w-full rounded-md shadow-sm sm:w-auto">
                                <button
                                    class="inline-flex justify-center rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5"
                                    @click="showNext">
                                    Add/View Products
                                </button>
                            </span>
                        </div>
                    </div>
                </div>
                <div v-if="stepTwo">
                    <div class="grid grid-cols-1 gap-4 pr-14 pl-8 pt-5 pb-2">
                        <div v-for="(item, index) in formData.details" :key="index" class="flex flex-wrap">
                            <div class="pb-2 pr-6 w-7/12">
                                <div class="pb-2">
                                    <label class="pb-2">SKU:</label>
                                </div>
                                <multiselect id="sku_id" :key="index" v-model="item.sku_id" placeholder="Search SKU"
                                    :options="skus" :clear-on-select="false" :preserve-search="true" :searchable="true"
                                    class="mt-1 w-1/2" :close-on-select="true" :create-option="true"
                                    :error="showValidationErrors(`details.${index}.sku_id`)"
                                    :style="showValidationErrors(`details.${index}.sku_id`) ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''" />
                                <p v-if="$props.errors" class="text-red-700 pt-2">
                                    <small>{{ showValidationErrors(`details.${index}.sku_id`) }}</small>
                                </p>
                            </div>
                            <div class="pb-2 pr-6 w-4/12">
                                <text-input :key="index" v-model="item.quantity"
                                    :error="showValidationErrors(`details.${index}.quantity`)" label="Quantity"
                                    class="pb-2 pr-6 w-full lg:w-full" />
                            </div>
                            <div class="pb-2 pr-6 w-1/12">
                                <svg v-show="formData.details.length > 1" xmlns="http://www.w3.org/2000/svg" fill="none"
                                    viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                                    class="w-6 h-6 text-red-600 mt-8"
                                    style="display: inline !important; cursor: pointer;"
                                    @click="removeItem(index, formData.details)">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                                <svg v-show="index === countOrders" xmlns="http://www.w3.org/2000/svg" fill="none"
                                    viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                                    class="w-6 h-6 mt-8 text-green-600"
                                    style="display: inline !important; cursor: pointer;" @click="addItem">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>

                            </div>
                        </div>
                    </div>
                    <div class="grid grid-cols-1 gap-4 pr-14 pl-8 pt-2 pb-2">
                        <div class="flex flex-wrap">
                            <select-input v-model="formData.partial_delivery" :error="$props.errors.partial_delivery"
                                class="pr-6 w-1/2 lg:w-1/2" label="Partial Delivery">
                                <option :value="null">-Select-</option>
                                <option :value="0">No</option>
                                <option :value="1">Yes</option>
                            </select-input>
                            <select-input v-model="formData.voucher" :error="$props.errors.voucher"
                                class="pr-6 w-1/2 lg:w-1/2" label="Voucher Code">
                                <option :value="null">-Select-</option>
                                <option v-for="voucher in vouchers" :key="voucher.id" :value="voucher.id">{{
                voucher.code }}
                                </option>
                            </select-input>
                        </div>
                    </div>
                    <div class="grid grid-cols-1 gap-4 pr-14 pl-8 pt-2 pb-2">
                        <div v-show="formData.shipping_type == 'Delivery'" class="flex flex-wrap">
                            <text-input v-model="formData.kilometer"
                                :error="$props.errors.kilometer" label="Extra Kilometers"
                                class="pb-2 pr-6 w-full lg:w-full" />
                        </div>
                    </div>
                    <div class="grid grid-cols-1 gap-4 pr-14 pl-8 pt-2 pb-2">
                        <div class="flex flex-wrap">
                            <span class="flex w-full rounded-md shadow-sm sm:w-auto">
                                <button
                                    class="inline-flex justify-center rounded-md border border-transparent px-4 py-2 bg-green-600 ml-0 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5"
                                    @click="showBack">
                                    View Order Header
                                </button>
                            </span>
                        </div>
                    </div>
                    <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
                        <a class="flex items-center btn-orange" href="#" @click="confirmOrderModal">Update</a>
                    </div>
                </div>

            </form>
        </div>
    </div>
    <div v-if="isConfirmOrderCreation" class="fixed z-10 inset-0 overflow-y-auto">
        <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <div class="fixed inset-0 transition-opacity">
                <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
            </div>
            <!-- This element is to trick the browser into centering the modal contents. -->
            <span class="hidden sm:inline-block sm:align-middle sm:h-screen"></span>
            <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
                role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                <form>
                    <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                        <div class="mb-4">
                            <p>
                                You are about to update an order. Proceed?
                            </p>
                        </div>
                        <div v-if="(popUpErrors)"
                            class="flex items-center justify-between mb-8 max-w-3xl bg-red-500 rounded">
                            <div class="flex items-center">
                                <svg class="flex-shrink-0 ml-4 mr-2 w-4 h-4 fill-white"
                                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                    <path
                                        d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm1.41-1.41A8 8 0 1 0 15.66 4.34 8 8 0 0 0 4.34 15.66zm9.9-8.49L11.41 10l2.83 2.83-1.41 1.41L10 11.41l-2.83 2.83-1.41-1.41L8.59 10 5.76 7.17l1.41-1.41L10 8.59l2.83-2.83 1.41 1.41z" />
                                </svg>
                                <div v-if="$page.props.flash.error" class="py-4 text-white text-sm font-medium">{{
                $page.props.flash.error }}</div>
                                <div v-else class="py-4 text-white text-sm font-medium">
                                    <span v-if="Object.keys($page.props.errors).length === 1">There is one form error.
                                        Please click the cancel button to fix it.</span>
                                    <span v-else>There are {{ Object.keys($page.props.errors).length }} form errors.
                                        Please click the cancel button to fix them.</span>
                                </div>
                            </div>
                            <button type="button" class="group mr-2 p-2" @click="show = false">
                                <svg class="block w-2 h-2 fill-red-800 group-hover:fill-white"
                                    xmlns="http://www.w3.org/2000/svg" width="235.908" height="235.908"
                                    viewBox="278.046 126.846 235.908 235.908">
                                    <path
                                        d="M506.784 134.017c-9.56-9.56-25.06-9.56-34.62 0L396 210.18l-76.164-76.164c-9.56-9.56-25.06-9.56-34.62 0-9.56 9.56-9.56 25.06 0 34.62L361.38 244.8l-76.164 76.165c-9.56 9.56-9.56 25.06 0 34.62 9.56 9.56 25.06 9.56 34.62 0L396 279.42l76.164 76.165c9.56 9.56 25.06 9.56 34.62 0 9.56-9.56 9.56-25.06 0-34.62L430.62 244.8l76.164-76.163c9.56-9.56 9.56-25.06 0-34.62z" />
                                </svg>
                            </button>
                        </div>
                    </div>
                    <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                        <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
                            <button type="button" class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2
                bg-green-500 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500
                focus:outline-none focus:border-green-700 focus:shadow-outline-green sm:text-sm
                sm:leading-5" @click="update('update-and-confirm')">
                                Update and Confirm
                            </button>
                        </span>
                        <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
                            <button type="button" class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2
                bg-orange-500 text-base leading-6 font-medium text-white shadow-sm hover:bg-orange-500
                focus:outline-none focus:border-orange-700 focus:shadow-outline-orange sm:text-sm
                sm:leading-5" @click="update()">
                                Update
                            </button>
                        </span>
                        <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
                            <button @click="closeConfirmOrderModel" type="button"
                                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5">
                                Cancel
                            </button>
                        </span>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import LoadingButton from '@/Shared/LoadingButton'
import TextInput from '@/Shared/TextInput'
import Multiselect from '@vueform/multiselect'
import SelectInput from '@/Shared/SelectInput'

export default {
    components: {
        Head,
        Icon,
        Link,
        LoadingButton,
        TextInput,
        Multiselect,
        SelectInput,
    },
    layout: Layout,
    props: {
        order: Object,
        referrals: Object,
        sources: Object,
        errors: Object,
        skus: Object,
        payment_details: Array,
        shipping_types: Array,
        points_of_sale: Array,
        pickup_locations: Array,
        providers: Object,
        agents: Object,
        logged_in_user_id: Number,
        vouchers: Object,
        cities: Array,
        delivery_types: Array,
        orderTypes: Array,
    },
    data() {
        return {
            form: this.$inertia.form({
                order_id: null,
                order_no: null,
                phone_number: null,
                amount: null,
                customer_name: null,
                city_id: null,
                physical_address: null,
            }),
            stepOne: true,
            stepTwo: false,
            formData: {
                'payment_detail': this.order.payment_detail_item,
                'shipping_type': this.order.shipping_type,
                'point_of_sale': this.order.point_of_sale,
                'delivery_date': this.order.delivery_date,
                'pickup_location': this.order.pickup_location,
                'customer': this.order.customer_id,
                'referral': this.order.referral,
                'notes': this.order.notes,
                'voucher': this.order.voucher_id,
                'partial_delivery': this.order.partial_delivery,
                'responsible_agent': this.order.agent_id,
                'transport': this.order.transport,
                'details': this.order.details,
                'payments': this.order.payments,
                'kilometer': this.order.kilometer,
                'city_id': this.order.city_id,
                'physical_address': this.order.physical_address,
                'delivery_location': this.order.delivery_location,
                'freshchat_user_id': null,
                'freshchat_conversation_id': null,
                'order_type': this.order.order_type,
                'assisting_agent': this.order.assisting_agent ? this.order.assisting_agent.id : '',
            },
            isConfirmOrderCreation: false,
            popUpErrors: null,
            forOutsideNairobi: false
        }
    },
    computed: {
        countOrders() {
            if (this.formData.details.length === 0) {
                return 0
            }
            return this.formData.details.length - 1
        },
        user() {
            return this.$inertia.page.props.auth.user
        },
        countOrderDetails() {
            if (this.formData.details.length === 0) {
                return 0
            }
            return this.formData.details.length - 1
        },
        countOrderPayments() {
            if (this.formData.payments.length === 0) {
                return 0;
            }
            return this.formData.payments.length - 1;
        },
    },
    methods: {
        confirmOrderModal() {
            this.isConfirmOrderCreation = true
        },
        closeConfirmOrderModel() {
            this.isConfirmOrderCreation = false
        },
        update(value) {
            this.formData._method = 'put'
            this.formData.action = 'update'
            if (value == 'update-and-confirm') {
                this.formData.action = value
            }
            this.$inertia.post(`/online-orders/${this.order.id}`, this.formData, {
                onSuccess: () => {
                    this.formData.payment_detail = null
                    this.formData.shipping_type = null
                    this.formData.point_of_sale = null
                    this.formData.delivery_date = null
                    this.formData.pickup_location = null
                    this.formData.customer = null
                    this.formData.referral = null
                    this.formData.notes = null
                    this.formData.partial_delivery = null
                    this.formData.voucher = null
                    this.formData.transport = 0
                    this.formData.action = null
                    this.formData.details = [{
                        sku_id: null,
                        quantity: null,
                    }]
                    this.stepOne = true
                    this.stepTwo = false
                    this.isConfirmOrderCreation = false
                },
                onError: (error) => {
                    this.popUpErrors = error
                },
            })
        },
        showNext() {
            this.stepOne = false
            this.stepTwo = true
        },
        showBack() {
            this.stepOne = true
            this.stepTwo = false
        },
        addItem(e) {
            e.preventDefault()
            this.formData.details.push({
                part_number: null,
                quantity: null,
            })
        },
        removeItem(index, details) {
            details.splice(index, 1)
        },
        addPaymentItem(e) {
            e.preventDefault()
            this.formData.payments.push({
                id: null,
                payment_provider: null,
                reference: null,
                date: null,
                amount: null,
            })
        },
        removePaymentItem(index, payments) {
            payments.splice(index, 1)
        },
        showValidationErrors(value) {
            if (this.$props.errors) {
                const error = this.$props.errors[value] || ''
                return error || ''
            }
            return ''
        },
        onSearchReferralChange: throttle(function (referral) {
            if (referral) {
                this.$inertia.get(`/online-orders/${this.order.id}/edit`, {referral}, {
                    preserveState: true,
                    preserveScroll: true,
                    replace: true,
                })
            }
        }, 200),
    }
}
</script>

<style src="@vueform/multiselect/themes/default.css"></style>

<style type="text/css">
.multiselect-option.is-selected.is-pointed {
    background: var(--ms-option-bg-selected-pointed, #fb923c);
    color: var(--ms-option-color-selected-pointed, #fff);
}

.multiselect-option.is-selected {
    background: var(--ms-option-bg-selected-pointed, #fb923c);
    color: var(--ms-option-color-selected-pointed, #fff);
}

.modal-wrapper h1 {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 10px;
    margin-top: 10px;
}
</style>